import {
  Card,
  CardHeader,
  CardFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
  Input,
  Button,
  Spinner,
} from "reactstrap";
import { useState, useEffect } from "react";
import axios from "axios";
import Header from "components/Headers/Header";

const Repositorio = () => {
  const [list1, setList1] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    setLoading(true);
    axios({
      auth: {
        username: process.env.REACT_APP_API_USER,
        password: process.env.REACT_APP_API_PASS,
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "get",
      url: `https://contratosback-dev.azurewebsites.net/api/v1/ObtieneHistorico/nit/0`,
    })
      .then((response) => {
        if (response.data.length > 0) {
          setList1(response.data);
          setFilteredData(response.data);
        } else {
          setError("No se encontraron datos.");
        }
      })
      .catch(() => {
        setError("Error al obtener los datos. Intente nuevamente.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);
    setFilteredData(
      list1.filter((item) =>
        Object.values(item).some(
          (field) => field && field.toString().toLowerCase().includes(value)
        )
      )
    );
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <h3 className="mb-0">Soportes</h3>
              <CardHeader className="border-0 d-flex justify-content-between">
                <hr />
                <Input
                  type="text"
                  placeholder="Buscar..."
                  value={searchTerm}
                  onChange={handleSearch}
                />
              </CardHeader>

              {loading ? (
                <div className="text-center p-4">
                  <Spinner color="primary" />
                </div>
              ) : error ? (
                <div className="text-center p-4 text-danger">{error}</div>
              ) : (
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th>ID</th>
                      <th>ID Ticket</th>
                      <th>No. Contrato</th>
                      <th>Razón Social</th>
                      <th>NIT</th>
                      <th>Objeto Contrato</th>
                      <th>Monto</th>
                      <th>Área Solicitante</th>
                      <th>Tipo Contrato</th>
                      <th>Estado</th>
                      <th>Contrato Origen</th>
                      <th>Comprador</th>
                      <th>Fecha Inicio</th>
                      <th>Fecha Fin</th>
                      <th>Preaviso</th>
                      <th>Renovación</th>
                      <th>Forma de Pago</th>
                      <th>Supervisión</th>
                      <th>Correo Comprador</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.map((item) => (
                      <tr key={item.id}>
                        <td>{item.id}</td>
                        <td>{item.idTicket}</td>
                        <td>{item.noContrato}</td>
                        <td>{item.razonSocial}</td>
                        <td>{item.nit}</td>
                        <td>{item.objetoContrato}</td>
                        <td>{item.monto}</td>
                        <td>{item.areaSolicitante}</td>
                        <td>{item.tipoContrato}</td>
                        <td>{item.estado}</td>
                        <td>{item.contratoOrigen || "N/A"}</td>
                        <td>{item.comprador}</td>
                        <td>{item.fechaInicio}</td>
                        <td>{item.fechaFin}</td>
                        <td>{item.preaviso}</td>
                        <td>{item.renovacion}</td>
                        <td>{item.formaPago || "N/A"}</td>
                        <td>{item.supervisionContrato}</td>
                        <td>{item.correoComprador}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}

              <CardFooter className="py-4">
                <nav aria-label="...">
                  <Pagination className="pagination justify-content-end mb-0">
                    <PaginationItem disabled={currentPage === 1}>
                      <PaginationLink
                        onClick={() => setCurrentPage(currentPage - 1)}
                      >
                        <i className="fas fa-angle-left" />
                      </PaginationLink>
                    </PaginationItem>
                    {[...Array(totalPages).keys()].map((page) => (
                      <PaginationItem
                        active={page + 1 === currentPage}
                        key={page}
                      >
                        <PaginationLink
                          onClick={() => setCurrentPage(page + 1)}
                        >
                          {page + 1}
                        </PaginationLink>
                      </PaginationItem>
                    ))}
                    <PaginationItem disabled={currentPage === totalPages}>
                      <PaginationLink
                        onClick={() => setCurrentPage(currentPage + 1)}
                      >
                        <i className="fas fa-angle-right" />
                      </PaginationLink>
                    </PaginationItem>
                  </Pagination>
                </nav>
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Repositorio;
